import { useCallback, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";

import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { ROTA_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});

interface IRotaUpdateImpactBody {
  clinic_id: string;
  staff_id: string;
  rota_date: string;
  rota_id: string;
  shift_timings?: {
    start_time: string;
    end_time: string;
  }[];
}

interface IRotaUpdateImpactResponse {
  status: boolean;
  message: string;
  data?: {
    booking_count: number;
  };
}

export const useRotaUpdateImpactAPI = () => {
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();

  const [loading, setLoading] = useState(false);

  const execute = useCallback(
    async (body: IRotaUpdateImpactBody) => {
      try {
        setLoading(true);

        const accessToken = localStorage.getItem(
          configuration.localStorage.ACCESS_TOKEN.key
        );

        const response: AxiosResponse<IRotaUpdateImpactResponse> =
          await axios.post(
             ROTA_APIS?.ROTA_UPDATION_WARN_API?.baseURL,
            body,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            }
          );

        return response.data;
      } catch (e: any) {
        const error = e as AxiosError;

        if (error?.config) {
          sendCurl((error.config as any)?.curlCommand);
        }

        captureError(error);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [configuration, captureError, sendCurl]
  );

  return { execute, loading };
};